import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import LanguagePopover from "src/components/LanguagePopover/LanguagePopover";
import LogoIso from "src/components/LogoIso";
import useResponsive from "src/hooks/useResponsive";

// ----------------------------------------------------------------------

const HeaderStyle = styled("header")(({ theme }) => ({
	top: 0,
	zIndex: 9,

	width: "100%",
	display: "flex",
	alignItems: "center",
	position: "absolute",
	padding: theme.spacing(3),
	justifyContent: "space-between",
	[theme.breakpoints.up("md")]: {
		padding: theme.spacing(7, 5, 0, 7)
	},
	[theme.breakpoints.down("sm")]: {
		position: "relative"
	}
}));

export const Header = () => {
	const smUp = useResponsive("up", "sm");

	return (
		<HeaderStyle>
			<LogoIso />
			<Stack
				alignItems='center'
				direction='row'
				sx={{ alignSelf: !smUp ? "center" : "flex-start" }}
			>
				<LanguagePopover />
			</Stack>
		</HeaderStyle>
	);
};

export default Header;
